import { render, staticRenderFns } from "./Barchart.vue?vue&type=template&id=478faefe&"
import script from "./Barchart.vue?vue&type=script&lang=js&"
export * from "./Barchart.vue?vue&type=script&lang=js&"
import style0 from "./Barchart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Barchart.vue"
export default component.exports